export enum MedicalExamTypes {
  LABORATORY_RESULTS = 'LABORATORY_RESULTS',
  ULTRASOUND = 'ULTRASOUND',
  XRAY = 'XRAY/MAMMOGRAPHY',
  RESONANCE = 'RESONANCE/TOMOGRAPHY',
  ELECTROCARDIOGRAM = 'ELECTROCARDIOGRAM',
  OTHER = 'OTHER',
}
